import { render, staticRenderFns } from "./CockpitMatryoshka.vue?vue&type=template&id=01279459&scoped=true"
import script from "./CockpitMatryoshka.vue?vue&type=script&lang=js"
export * from "./CockpitMatryoshka.vue?vue&type=script&lang=js"
import style0 from "./CockpitMatryoshka.vue?vue&type=style&index=0&id=01279459&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01279459",
  null
  
)

export default component.exports